import Modal from "@/components/common/modal";
import { PasswordField } from "@/components/common/password-field";
import { DialogFooter } from "@/components/ui/dialog";
import { schema, type ConfirmSignature } from "@/schemas/procedures/signature";

import { Button, TextField } from "@elaniintc/goes-design-system";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

interface Props {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onAccept: (val: { pin: string; user: string; password: string }) => void;
}

const SignatureModal = ({ isOpen, isLoading, onClose, onAccept }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<ConfirmSignature>({
    resolver: zodResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const onSubmit = async (data: ConfirmSignature) => {
    onAccept({
      pin: data.pin,
      user: data.user,
      password: data.password,
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Firma de documento"
      description="Ingresa tus credenciales para la firma certificada."
      modalContentClassName="max-w-[520px] w-full gap-7"
    >
      <form
        className="flex flex-col gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleSubmit(onSubmit)(e);
        }}
        id="edit-role-form"
      >
        <TextField
          label="Usuario"
          required
          placeholder="Escribe tu usuario"
          {...register("user")}
          error={errors.user?.message}
        />
        <PasswordField
          label="Contraseña"
          type="password"
          required
          placeholder="Escribe tu contraseña"
          {...register("password")}
          error={errors.password?.message}
        />
        <PasswordField
          label="PIN de firma certificada"
          required
          placeholder="Ingresa tu PIN"
          {...register("pin")}
          type="password"
          error={errors.pin?.message}
        />
        <DialogFooter className="pt-6">
          <div className="w-full grid grid-cols-1 tablet:grid-cols-2 gap-3">
            <Button
              size="lg"
              type="button"
              className="w-full rounded-lg"
              variant="tertiary"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              size="lg"
              variant="default"
              className="w-full rounded-lg"
              type="submit"
              disabled={!isValid}
              isLoading={isLoading}
            >
              Aceptar
            </Button>
          </div>
        </DialogFooter>
      </form>
    </Modal>
  );
};

export default SignatureModal;
